import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

import { useAppSelector } from 'hooks';
import useClientWidth from 'hooks/useClientWidth';
import { getYMEventPayload } from 'portfolio3/features/yandexMetrika';
import { isDefined } from 'utils';

import { PerformanceDiagram, PerformanceTiles } from '../../../../components/redesignStudent';
import SubjectThemesDrawer from '../components/SubjectThemesDrawer';
import { getStudentSubjectThemesActions } from '../model/actions';
import { MarkType, VisibilityType } from '../types';
import { sortPerformanceByLearningYear } from '../utils';
import PerformanceChartContainer from './PerformanceChartContainer';
import { IPerformanceContainerProps, IYearPerformance } from './PerformanceContainer.types';

const getFilteredPerfomance = (perfomance: IYearPerformance): IYearPerformance => ({
  averageMarkFive: perfomance.averageMarkFive,
  // Исключаем значения, для которых указан nonMarkValue
  subjectsPerformance: perfomance.subjectsPerformance.filter(
    (subjectsPerformance) => !subjectsPerformance.nonMarkValue,
  ),
});

const PerformanceContainer: React.FC<IPerformanceContainerProps> = ({
  currentPerformance,
  currentVisibilityType,
  markType,
}) => {
  const dispatch = useDispatch();
  const currentStudent = useAppSelector((state) => state.currentStudent);
  const subjectThemesCache = useAppSelector((state) => state.studentSubjectThemesCache);

  const [selectedSubjectId, setSelectedSubjectId] = useState<number | undefined>(undefined);
  const [isSubjectThemesDrawerOpen, setSubjectsThemesDrawerOpen] = useState(false);
  const clientWidth = useClientWidth();

  // const sortedChartPerformance = sortPerformanceByLearningYear(currentPerformance.content, 'asc');

  const handleCloseMobileDetails = useCallback(() => {
    setSubjectsThemesDrawerOpen(false);
  }, []);

  const handleChangeActiveSubject = (subjectId: number) => {
    if (subjectId === selectedSubjectId) return;

    setSelectedSubjectId(subjectId);

    dispatch(getStudentSubjectThemesActions.invalidate());
    const isCached = isDefined(subjectThemesCache[subjectId]);

    if (subjectId && !isCached) {
      const subjectsList = Array.isArray(currentPerformance)
        ? currentPerformance
        : currentPerformance?.subjectsPerformance;
      const subjectName = subjectsList.find((subject) => subject.subjectId === subjectId)?.subjectName;
      const ymMeta = getYMEventPayload({ type: 'subjectChoosingStudy', payload: { subject: subjectName ?? '' } });

      dispatch(getStudentSubjectThemesActions.request(currentStudent.meshId, subjectId, ymMeta));
    }
  };

  // if (!hasCurrentYearPerformance) {
  //   return (
  //     <NoDataPlug
  //       image={placeholderGeometry}
  //       title="Данных по предметным результатам за выбранный период пока нет"
  //       loading={isLoading}
  //     />
  //   );
  // }

  const diagramCurrenPerfomance =
    markType === MarkType.FINAL ? getFilteredPerfomance(currentPerformance) : currentPerformance;

  return (
    <>
      {currentVisibilityType === VisibilityType.DIAGRAM && (
        <PerformanceDiagram
          yearPerformance={diagramCurrenPerfomance}
          selectedSubjectId={selectedSubjectId}
          onSelectSubject={handleChangeActiveSubject}
          isInteger={markType === MarkType.FINAL}
        />
      )}
      {currentVisibilityType === VisibilityType.TILES && (
        <PerformanceTiles
          yearPerformance={currentPerformance}
          selectedSubjectId={selectedSubjectId}
          onSelectSubject={handleChangeActiveSubject}
          isInteger={markType === MarkType.FINAL}
        />
      )}
      {/* {clientWidth < 767 && selectedSubjectId && (
        <SubjectThemesDrawer
          isOpen={isSubjectThemesDrawerOpen}
          yearPerformance={currentYearPerformance}
          selectedSubjectId={selectedSubjectId}
          onClose={handleCloseMobileDetails}
        />
      )} */}
      {currentVisibilityType === VisibilityType.CHART && <PerformanceChartContainer />}
    </>
  );
};

export default PerformanceContainer;
